import React from 'react'
import Tooltip from 'rc-tooltip'

export const FAIconCircle = ({
  children, size = '9px', bgcolor = 'primary',
  fgcolor = 'white', onClick, htmlToolTip = false,
  placement = 'top', toolTip = undefined, overlayClassName = undefined,
  icon = undefined, type = 's'
}) => {
  const style = {
    fontSize: size
  }
  if (onClick) {
    style.cursor = 'pointer'
  }

  const ctrl = <span style={style} onClick={onClick} className="fa-stack">
    <i className={`fa fa-circle fa-stack-2x text-${bgcolor}`}></i>
    {icon
      ? <i className={`fa${type || 's'} fa-${icon} fa-stack-1x text-${fgcolor}`} />
      : <strong className={`fa-stack-1x text-${fgcolor}`}>{children}</strong>
    }
  </span>

  if (toolTip) {
    return (
      <Tooltip mouseEnterDelay={0.5} placement={placement} overlayClassName={`${overlayClassName || ''} ${bgcolor || ''}`} overlay={htmlToolTip ? <span dangerouslySetInnerHTML={{ __html: toolTip }}></span> : toolTip}>
        {ctrl}
      </Tooltip>
    )
  } else {
    return ctrl
  }
}
